import { Injectable } from '@angular/core';
import { ImportDetailStatus } from './models/pincard/importdetailstatus.model';

@Injectable()
export class ImportDetailStatusService {
  constructor() {}

  getListImportDetailStatus(): ImportDetailStatus[] {
    let statusList: ImportDetailStatus[] = [];
    statusList.push(new ImportDetailStatus(6, 'Chờ Import'));
    statusList.push(new ImportDetailStatus(5, 'Trùng serial'));
    statusList.push(new ImportDetailStatus(4, 'Không khớp mệnh giá'));
    statusList.push(new ImportDetailStatus(3, 'Gần hết hạn'));
    statusList.push(new ImportDetailStatus(2, 'Mới'));
    statusList.push(new ImportDetailStatus(1, 'Đã import'));
    statusList.push(new ImportDetailStatus(0, 'Khóa'));

    return statusList;
  }
}
